import DefaultController from 'root/main/core/ajax/ajaxContentControllers/defaultController';
export default class PopupController extends DefaultController {
    getElementToChange() {
        return ['#content-wrapper', '.main-site-header'];
    }

    load() {
        'use strict';
        if (!this.hasBeenClosed()) {
            this.elementToInsert = this.gethtmlToInsert();
            this.addEventListernerToElement();
            this.insetElement();
        }
    }

    insetElement() {
        var fn = this[this.data.DOMinsert.method];

        // var elToInset = this.
        if (typeof fn === 'function') {
            fn(this.data.DOMinsert.target, this.elementToInsert);
        }
    }

    addEventListernerToElement() {
        let target = this.elementToInsert.querySelector(
            `[data-alert=close-btn_${this.name}]`
        );
        let cta = this.elementToInsert.querySelector(`[data-alert=cta]`);
        target.addEventListener('click', this.closeHandler.bind(this, true));
        cta.addEventListener('click', this.closeHandler.bind(this, false));
    }

    closeHandler(hide) {
        this.cm.setCookie(this.getCookieName(), 1, 90);
        if (hide === true) this.elementToInsert.style.display = 'none';
    }

    hasBeenClosed() {
        var cookieValue = this.cm.getCookie(this.getCookieName());
        if (cookieValue === 1) {
            return true;
        }
        return false;
    }

    getCookieName() {
        // Cookies names with prefix '_ls' are not cached by WPE
        return '_ls-' + this.name;
    }
}
